export default __webpack_public_path__ + "static/media/Non-cash.7b7499ca.svg";